import { render } from "./DashboardsCard.vue?vue&type=template&id=23b0378e&scoped=true&ts=true"
import script from "./DashboardsCard.vue?vue&type=script&lang=ts"
export * from "./DashboardsCard.vue?vue&type=script&lang=ts"

import "./DashboardsCard.vue?vue&type=style&index=0&id=23b0378e&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b0378e"]])

export default __exports__